/**
 * The retailer ids Meta holds for our products. These are a cross-repo contract: the backend
 * catalog sync writes the same strings (web repo: `lib/facebook/services/productCatalogSync.ts`)
 * and Meta matches them literally, so a rename on either side silently breaks retargeting with
 * no error anywhere.
 *
 * Deliberately dependency-free. Everything else in the analytics folder reaches the redux store,
 * and through it React views and their ESM-only packages, which react-scripts' jest cannot
 * transform — so a test for this contract could not import it from there.
 */

/** Catalog product id for a collar variant, or the product line when there is no variant. */
export function getCatalogProductId(familyName: string, variantName?: string) {
  return variantName ? `${familyName} ${variantName}` : familyName;
}

/**
 * Catalog ids for non-collar products. Accessories have no product family, so they report
 * these directly. Must match `accessoryCatalogInfo` in the web repo's productCatalogSync.
 */
export const CATALOG_ID_SERIES_3_PLUS_BAND = 'Series 3+ Band';
export const CATALOG_ID_MARTINGALE_BAND = 'Martingale Band';
export const CATALOG_ID_CHARGING_BASE = 'Series 3+ Charging Base';

/** Keyed by the SKUType string values in UpsellV2. */
export const CATALOG_ID_BY_SUPPLEMENT_SKU_TYPE: Record<string, string> = {
  '8-in-1 Formula': 'Multivitamin Supplement',
  'Hip & Joint': 'Hip & Joint Supplement',
  'Skin & Coat': 'Skin & Coat Supplement',
  Calming: 'Calming Supplement',
};

/**
 * Only the colourways that exist as catalog items. Anything else (scribble bands, Strava)
 * falls back to the product-line id rather than emitting an id nothing can match.
 */
export const CATALOG_VARIANT_BY_COLOR: Record<string, string> = {
  yellow: 'Yellow',
  blue: 'Blue',
  gray: 'Gray',
  pink: 'Pink',
};
